import React, { useMemo, useState } from 'react';
import Checkbox from 'shared/components/checkbox/Checkbox';
import SelectComponent from 'shared/elements/select/select.component';
import {
  ActionTypes,
  ProgramTypes,
  RECURRENCE_DAYS,
  RECURRENCE_PATTERN,
  RECURRENCE_PATTERN_LIST,
} from '../ChannelArchitecture.d';
import '../ChannelArchitecture.css';

function DailyRecurrencePatternComponent({
  blockType,
  disabled,
  modalType,
  onChangeDays,
  onChangeRecurrence,
  recurrencePattern,
}) {
  const [selectAll, setSelectAll] = useState(true);

  const patternList = useMemo(() => {
    // blockType represents the currently selected block type in the modal (derived from
    // modalState), and modalType represents the type of modal being displayed.
    const isRepeatType = blockType === ProgramTypes.REPEAT;

    if (isRepeatType && modalType !== ActionTypes.REPEAT) return RECURRENCE_PATTERN_LIST;

    return RECURRENCE_PATTERN_LIST.filter((pattern) => pattern.id !== RECURRENCE_PATTERN.STACK);
  }, [blockType, modalType]);

  const handlePatternChange = (pattern) => {
    const isStackPattern = pattern.id === RECURRENCE_PATTERN.STACK;

    if (isStackPattern) setSelectAll(false);

    onChangeRecurrence({
      ...recurrencePattern,
      id: pattern.id,
      name: pattern.name,
      days: isStackPattern ? [] : recurrencePattern.days,
    });
  };

  const sortDays = (a, b) => {
    if ((a === 0) !== (b === 0)) {
      return a === 0 ? 1 : -1;
    }
    if (a === b) return 0;
    return a > b ? 1 : -1;
  };

  const handleDaysChange = (dayId) => {
    const isSelected = recurrencePattern.days.includes(dayId);
    const days = (
      isSelected
        ? recurrencePattern.days.filter((id) => id !== dayId)
        : [...recurrencePattern.days, dayId]
    ).sort(sortDays);

    onChangeDays(days);

    const allDaysInWeek = 7;
    if (days.length === allDaysInWeek) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  };

  const handleSelectAllChange = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);

    const days = newSelectAll ? RECURRENCE_DAYS.map((day) => day.id) : [];
    onChangeDays(days);
  };

  return (
    <div className="ca-daily-recurrence-pattern-wrapper">
      <div className="ca-daily-recurrence-pattern-header">
        <span>Recurrence pattern</span>
        <SelectComponent
          disabled={disabled}
          list={patternList}
          text={recurrencePattern.name}
          onSelect={handlePatternChange}
          optionStyle="recurrence-options"
          width="120px"
        />
      </div>

      <div className="ca-daily-recurrence-pattern-weekdays">
        <Checkbox
          disabled={disabled}
          label="Select All"
          active={selectAll}
          onCheck={handleSelectAllChange}
          fontClassName="ca-daily-recurrence-pattern-weekday-label"
          checkboxClassName="ca-daily-recurrence-pattern-weekday-checkbox"
        />
        <hr className="ca-daily-recurrence-pattern-separator" aria-orientation="vertical" />
        {RECURRENCE_DAYS.map((day) => (
          <Checkbox
            disabled={disabled}
            key={day.id}
            label={day.name}
            active={recurrencePattern.days.includes(day.id)}
            onCheck={() => handleDaysChange(day.id)}
            fontClassName="ca-daily-recurrence-pattern-weekday-label"
            checkboxClassName="ca-daily-recurrence-pattern-weekday-checkbox"
          />
        ))}
      </div>
    </div>
  );
}

export default DailyRecurrencePatternComponent;
